import React from "react";
import {motion} from "framer-motion"
import ResumeCard from "./ResumeCard";

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-12 font-titleFont flex gap-20"
    >
      <div>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2023 - 2025</p>
          <h2 className="text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Devops Manager"
            subTitle="Meddey - (2025 - Present)"
            result="New Delhi"
            des="I lead development and operations teams to streamline deployments, automate workflows, and ensure efficient, reliable application delivery."
          />
          <ResumeCard
            title="Sr. Automation Specialist"
            subTitle="Meddey - (2024 - 2025)"
            result="New Delhi"
            des="Built two websites and automated tasks like web scraping, order tracking, and ad campaigns to save time and boost efficiency for the company."
          />
          <ResumeCard
            title="Ecommerce Executive"
            subTitle="Golden Age Media - (2020 - 2011)"
            result="New Delhi"
            des="I manage e-commerce operations at Golden Age Media, focusing on WordPress, product updates, and site performance."
          />
        </div>
      </div>
      <div>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2020 - 2025</p>
          <h2 className="text-4xl font-bold">Training Experience</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Tech Mentor"
            subTitle="Meddey (2024 - 2025)"
            result="New Delhi"
            des="Conducted internal sessions on web automation, API integration, and Google Sheets scripting to train team members in streamlining business processes."
          />
          <ResumeCard
            title="Web Development Instructor"
            subTitle="Modi Training Institute (2023 - 2024)"
            result="New Delhi"
            des="Created video tutorials and live workshops on HTML, CSS, JavaScript, helping beginners become job-ready developers."
          />
          <ResumeCard
            title="Self-Taught Developer"
            subTitle="Project-Based Learning (2023 - 2025)"
            result="New Delhi"
            des="Built and deployed full-stack projects, automated manual business tasks, and mastered modern development workflows through consistent self-learning."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Experience;
